import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=a9ce882e&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"
import style0 from "./Customers.vue?vue&type=style&index=0&id=a9ce882e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce882e",
  null
  
)

export default component.exports